import { render, staticRenderFns } from "./Staffs.vue?vue&type=template&id=61e04c09&scoped=true"
import script from "./Staffs.vue?vue&type=script&lang=js"
export * from "./Staffs.vue?vue&type=script&lang=js"
import style0 from "./Staffs.vue?vue&type=style&index=0&id=61e04c09&prod&lang=scss&scoped=true"
import style1 from "./Staffs.vue?vue&type=style&index=1&id=61e04c09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e04c09",
  null
  
)

export default component.exports